import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(
      "https://script.google.com/macros/s/AKfycbwzZ8ZxzwZdv4wMrar8TCzUq29nwmoqzyQ_NK0KflrMKCOXQ7uVuCKGFpig1qGksNg/exec"
    )
      .then((res) => res.json())
      .then((data) => {
        setProducts(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error:", err);
        setLoading(false);
      });
  }, []);

  const handleClick = (id) => {
    navigate(`/product/${id}`);
  };

  if (loading) {
    return (
      <div style={styles.loadingContainer}>
        <p style={styles.loadingText}>Loading products...</p>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {products.map((item, index) => (
        <div
          key={index}
          style={styles.card}
          onClick={() => handleClick(item.id)}
        >
          <img src={item.image_url} alt={item.title} style={styles.image} />
          <h2 style={styles.title}>{item.title}</h2>
          <p style={styles.description}>{item.description}</p>
          <p style={styles.category}>{item.category}</p>
          <p style={styles.price}>
            <span style={styles.currentPrice}>${item.current_price}</span>{" "}
            <span style={styles.originalPrice}>${item.original_price}</span>
          </p>
          <a
            href={item.affiliate_link}
            target="_blank"
            rel="noreferrer"
            style={styles.button}
          >
            Buy Now
          </a>
        </div>
      ))}
    </div>
  );
};

const styles = {
  container: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    gap: "1.5rem",
    padding: "2rem",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "80vh",
  },
  loadingText: {
    fontSize: "1.5rem",
    color: "#1976d2",
  },
  card: {
    border: "1px solid #ddd",
    borderRadius: "12px",
    padding: "1rem",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
    transition: "transform 0.2s ease",
  },
  image: {
    width: "100%",
    height: "200px",
    borderRadius: "8px",
    marginBottom: "0.5rem",
  },
  title: {
    fontSize: "1.1rem",
    fontWeight: "bold",
    margin: "0.5rem 0",
  },
  description: {
    fontSize: "0.9rem",
    color: "#555",
    height: "4rem",
    overflow: "hidden",
  },
  category: {
    fontSize: "0.8rem",
    fontStyle: "italic",
    color: "#999",
  },
  price: {
    marginTop: "0.5rem",
    fontSize: "1rem",
  },
  currentPrice: {
    color: "#d32f2f",
    fontWeight: "bold",
  },
  originalPrice: {
    textDecoration: "line-through",
    marginLeft: "0.5rem",
    color: "#999",
  },
  button: {
    marginTop: "1rem",
    display: "inline-block",
    padding: "0.5rem 1rem",
    backgroundColor: "#1976d2",
    color: "#fff",
    borderRadius: "6px",
    textDecoration: "none",
    fontWeight: "bold",
    zIndex: "1111",
  },
};

export default Products;
